import {TreatmentTarget} from '../treatments/treatment_target'
export class PbxEndpointTreatment extends TreatmentTarget {
    constructor(domain_id, group_id) {
      super();
      this.domain_id = domain_id;
      this.group_id = group_id;
    }
    
    setTarget(target) {
      this.target = target
    }

    validate() {
      let response = {}
      this.querySelectorAll('.error').forEach(e => {
        e.classList.remove('error');
      })

      if(this.querySelector('.number_to_call_type').value == 'extension') {
        if(this.querySelector('.group_users').value == 'null') {
          this.querySelector('.group_users').classList.add('error');
          response.requiredMissing = true;
        }
      } else {
        if(!this.querySelector('.ring_to_number').value) {
          this.querySelector('.ring_to_number').classList.add('error');
          response.requiredMissing = true;
        }
      }
      return response;
    }

    getData() {
      let ring_to_endpoint = this.querySelector(".number_to_call_type").value == 'number' || this.querySelector(".number_to_call_type").value == 'sip' ? this.querySelector(".ring_to_number").value : null;
      let ring_to_user_id = this.querySelector(".number_to_call_type").value == 'extension' ? this.querySelector(".group_users").value : null;
      let target = 
        { 
          target_name: `Ring ${ring_to_endpoint || 'User'}`,
          target_type: "ENDPOINT", 
          ring_to_endpoint: ring_to_endpoint,
          ring_to_user_id: ring_to_user_id,
          ivr_target_audio_id: null,
          ivr_choice_timeout: null,
          children: [],
          actions: []
        }
      return target;
    }

    getIcon() {
      return 'fa-phone'
    }

    static getType() {
      return "ENDPOINT"
    }

    async connectedCallback() {
      let users_req = await fetch(`/admin/groups/${this.group_id}/users`)
      let users = await users_req.json();
      users = users.data.filter((user)=>user.user_profile != null && user.user_profile.first_name != "" && user.user_profile.last_name != "").map((user)=> {
        return `<option value='${user.id}'>${user.user_profile.first_name} ${user.user_profile.last_name} (${user.email})</option>"`
      });

      this.innerHTML = `
        <div class="col-sm-12 ct_action" data-action_type=ENDPOINT>
          <div class="panel panel-default">
              <h4>Ring Number</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
              <div class="form-group row">
                <div class="col-sm-12">
                  <label>Number to Call</label>
                </div>
                <div class="col-sm-6">
                  <select class="form-control number_to_call_type">
                    <option value="null">Select</option>
                    <option value="number">Number</option>
                    <option value="sip">SIP</option>
                    <option value="extension">User Extension</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <input is="ring-to-endpoint" type="text" class="form-control ring_to_number hidden" data-key="ring_to_number" placeholder="(123) 444-5566 or SIP Target" value="${this.target != null ? this.target.ring_to_endpoint : ""}">
                  <select class="form-control group_users hidden">
                    <option value="null">Select</option>
                    ${users}
                  </select>
                </div>
              </div>
          </div>
        </div>
        <!--div class="col-sm-12 ct_line">
          <div class="ct_vertical_arrow"></div>
          <div class="option_text">Sales Rep is being Called</div>
          <div class="ct_vertical_arrow">
            <div class=arrow-down></div>
          </div>
        </div-->
      `;
      super.connectedCallback();

      this.querySelector('.number_to_call_type').onchange = (e) => {this.handleNumber(e.target.value)}

      if(this.target) {
        if(this.target.ring_to_endpoint && !this.target.ring_to_domain) {
          this.querySelector('.number_to_call_type').value = 'number';
          this.handleNumber('number');
        } else if(this.target.ring_to_domain) {
          this.querySelector('.number_to_call_type').value = 'sip';
          this.handleNumber('sip');
        } else if(this.target.ring_to_user_id) {
          this.querySelector('.number_to_call_type').value = 'extension';
          this.querySelector('.group_users').value = this.target.ring_to_user_id;
          this.handleNumber('extension');
        }
      }
    }

    handleNumber(type) {
      if(type == 'number' || type == 'sip') {
        this.querySelector('.ring_to_number').classList.remove('hidden');
        this.querySelector('.group_users').classList.add('hidden');
      } else if (type == 'extension') {
        this.querySelector('.ring_to_number').classList.add('hidden');
        this.querySelector('.group_users').classList.remove('hidden');
      } else {
        this.querySelector('.ring_to_number').classList.add('hidden');
        this.querySelector('.group_users').classList.add('hidden');
      }
    }
  }
  customElements.define('pbx-ring-number-treatment', PbxEndpointTreatment);